import React from 'react';
import { Link } from 'react-router-dom';
import AppsLayout from './AppsLayout';
import Button from './components/Button';
import { PolicyArticle, PolicyContents } from './components/PolicyContent';
import policy from '../../content/numbcrunch/privacy.json';
import { trackClick } from '../../firebase/analytics';
import { APPS_ROUTES } from './routes';

const PAGE = 'apps_numbcrunch_privacy';

export default function NumbCrunchPrivacyPage() {
  return (
    <AppsLayout
      title="NumbCrunch privacy policy · Keval Langalia"
      description="The complete NumbCrunch Android game privacy policy: on-device settings, tutorial progress, game rounds, Android backups, Google Play and privacy for children."
      canonicalPath={APPS_ROUTES.numbcrunchPrivacy}
      breadcrumbs={[
        { label: 'Portfolio', to: APPS_ROUTES.apps, id: 'apps' },
        { label: 'NumbCrunch', to: APPS_ROUTES.numbcrunch, id: 'numbcrunch' },
        { label: 'Privacy policy' },
      ]}
      page={PAGE}
      support={false}
    >
      <header className="apps-policy-header">
        <p className="apps-eyebrow">{policy.app} · Privacy</p>
        <h1 className="apps-title">{policy.title}</h1>
      </header>
      <div className="apps-policy">
        <PolicyContents policy={policy} />
        <div>
          <PolicyArticle policy={policy} />
          <aside className="apps-notice apps-notice--info apps-policy-followup" aria-label="Website privacy policy note">
            <strong>Website privacy</strong>
            <p>
              This policy applies to the NumbCrunch Android app. For information on how this website (keval.io) uses optional analytics, cookies and browser storage, please review the{' '}
              <Link to="/privacy" className="kds-link" onClick={trackClick(PAGE, 'website_privacy_link')}>Website privacy policy</Link>.
            </p>
          </aside>
          <div className="apps-hero-actions apps-policy-followup">
            <Button to={APPS_ROUTES.numbcrunch} variant="secondary" onClick={trackClick(PAGE, 'back_to_numbcrunch_button')}>
              Back to NumbCrunch
            </Button>
            <Link to={APPS_ROUTES.apps} className="kds-btn kds-btn--text" onClick={trackClick(PAGE, 'all_apps_link')}>
              All projects
            </Link>
          </div>
        </div>
      </div>
    </AppsLayout>
  );
}
